import Vue from 'vue';

const getDateFromTimestamp = (timestamp) => {
  timestamp = parseInt(timestamp);
  const date = new Date(timestamp);
  const monthNames = [
    "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
  ];

  const dateWithFullMonthName = monthNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
  return dateWithFullMonthName;
};

const chatState = {
  unreadCounts: {},
  conversationIds: [],
  conversations: {},
  lastMessageTimestampsMap: {}
};

const chatActions = {
  async sendMessage(store, { message, destination, resourceId }) {
    let database = this._vm.firebase.database();
    const currentUserId = await store.dispatch("loggedInUserId");
    let data = {};
    data.timestamp = this._vm.firebase.database.ServerValue.TIMESTAMP;
    data.message = message;
    data.sender = currentUserId;
    data.destination = destination;
    let ref1 = database.ref().child('chat').child(currentUserId).child(destination + '|' + resourceId).child('messages').push();
    await ref1.set(data);
    const lastMessageTimestampRef = database.ref().child('chat').child(currentUserId).child(destination + '|' + resourceId).child('lastMessageTimestamp');
    await lastMessageTimestampRef.set(data.timestamp);
  },
  async getConversations(store) {
    const database = this._vm.firebase.database();
    const loggedInUserUid = await store.dispatch("loggedInUserId");
    if (loggedInUserUid) {
      const chatRef = database.ref().child("chat").child(loggedInUserUid);
      chatRef.on("child_added", function(snap) {
        const lastMessageTimestamp = snap.val().lastMessageTimestamp || 0;
        const conversationId = snap.key;
        Vue.set(store.state.lastMessageTimestampsMap, conversationId, lastMessageTimestamp);
        // const user_id = conversationId.split("|")[0];
        const [user_id, resource_id] = conversationId.split("|");
        store.dispatch("watchUser", user_id);
        // const resource_id = conversationId.split("|")[1];
        store.dispatch("watchResource", resource_id);
      });

      chatRef.on("child_changed", function(snap) {
        const lastMessageTimestamp = snap.val().lastMessageTimestamp || 0;
        const conversationId = snap.key;
        Vue.set(store.state.lastMessageTimestampsMap, conversationId, lastMessageTimestamp);
      });

    }
  },
  async watchTotalCount(store) {
    const database = this._vm.firebase.database();
    const currentUserId = await store.dispatch("loggedInUserId");
    const ref = database.ref().child('chat').child(currentUserId).orderByChild("unreadCount");
    ref.on("value", (snap) => {
      if (snap.val()) {
        const children = snap.val();
        for (let chatId in children) {
          const count = children[chatId].unreadCount;
          store.commit('setChatUnreadCounts', { chatId, count });
        }
      }
    });
  },
  async resetUnreadCount(store, { resourceId, destination }) {
    const database = this._vm.firebase.database();
    const currentUserId = await store.dispatch("loggedInUserId");
    const ref = database.ref().child('chat').child(currentUserId).child(destination + '|' + resourceId);
    ref.update({ unreadCount: 0 });
  },
};

const chatGetters = {
  getConversationIds: (state) => {

    return Object.entries(state.lastMessageTimestampsMap).
    sort(([id1, timestamp1], [id2, timestamp2]) => timestamp2 - timestamp1).
    map(([id, timestamp]) => id);
  },
  conversationsState: (state) => {
    if (Object.keys(state.lastMessageTimestampsMap).length) {
      return 'loaded';
    } else {
      return 'empty';
    }
  },
  conversations: (state) => {
    const chats = [];
    for (const id in state.conversationIds) {
      chats.push(id);
    }
    return chats;
  },
  getChatUnreadCount: (state) => {
    return Object.values(state.unreadCounts).reduce((previous, key) => {
      previous += key;
      return previous;
    }, 0);
  },
  getMyMessages: (state) => {
    let lastDate = "";
    let messageDate = "";
    const messages = [];
    for (let id in state.myMessages) {
      const message = state.myMessages[id];
      messageDate = getDateFromTimestamp(message.timestamp);
      if (messageDate !== lastDate) {
        lastDate = messageDate;
        // messages.push({ type: "dateSeperator", date: messageDate });
      }
      // console.log(message.timestamp);
      // console.log(lastDate);
      messages.push(message);
    }

    return messages;
  },
};

const chatMutations = {
  setConversationIds(state, conversationIds) {
    Vue.set(state, 'conversationIds', conversationIds);
  },
  setChatUnreadCounts(state, { chatId, count }) {
    Vue.set(state.unreadCounts, chatId, count);
  },
};



export {
  chatState,
  chatActions,
  chatGetters,
  chatMutations
};
